type ApprovalHandler = (message: string) => Promise<boolean>;

let handler: ApprovalHandler | null = null;

/** Registered by the custodial wallet provider while a connected wallet is available. */
export function setApprovalHandler(next: ApprovalHandler | null): void {
  handler = next;
}

/** Shows the approval screen. Resolves false when the player cancels. */
export function requestApprovalSignature(message: string): Promise<boolean> {
  if (!handler) return Promise.reject(new Error("Connect a wallet before approving"));
  return handler(message);
}
